<script setup lang="ts">
defineOptions({
	name: 'IntellectualPropertySection',
})

const { t: $t, locale } = useI18n()
const { $tThird } = useNuxtApp()

const firstHtml = computed(() => {
	return $tThird(
		'The {platform} and all its contents, encompassing but not limited to articles, opinions, texts, lists, user manuals, photographs, drawings, images, video clips, audio, marketing texts, trademarks, logos, domain names, and other elements subject to property rights (including source codes) and/or other intellectual property rights {materials}, are either the property of {company} or are utilised with authorisation from third parties. They are protected against unauthorised use, copying, or disclosure by national laws and international treaties related to intellectual property rights.',
		{
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			materials: `(“<span class="font-semibold">${$t('Materials')}</span>”)`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const secondHtml = computed(() => {
	return $tThird(
		'Nothing in these {terms} or the content on the {platform} should be interpreted as granting, accepting, or otherwise providing the right to use any Material in any way without the prior written consent of {company} or the third-party owner of the Material or the intellectual property rights published on the {platform}.',
		{
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const thirdHtml = computed(() => {
	return $tThird(
		'The use, copying, reproduction, modification, republishing, updating, downloading, email transmission, distribution, duplication, or any other misuse of the Material not explicitly identified but of a similar nature is strictly prohibited. As {users}, they agree not to use the Material for any unlawful purpose and not to infringe upon the rights of {company}.',
		{
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('User') : $t('Users')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const fourthHtml = computed(() => {
	return $tThird(
		'Nevertheless, {users} may view and display the {platform} contents and Materials on a computer or electronic device screen, store such content electronically on a personal disk (excluding servers or internet-connected storage devices), or print such content for personal, non-commercial use.',
		{
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			platform: `<span class="font-semibold">${locale.value === 'fr' ? $t('Platform') : $t('Platform’s')}</span>`,
		},
	)
})

const fivethHtml = computed(() => {
	return $tThird(
		'{users} are granted a limited, non-exclusive, non-transferable, and revocable licence to access and use the Platform for personal and non-commercial purposes only.',
		{
			users: `<span class="font-semibold capitalize">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
		},
	)
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-iconoir:brain"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $tThird('Intellectual Property') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p v-html="firstHtml"></p>
			<p v-html="secondHtml"></p>
			<p v-html="thirdHtml"></p>
			<p v-html="fourthHtml"></p>
			<p v-html="fivethHtml"></p>
		</div>
	</section>
</template>
